module.exports = __webpack_public_path__ + "img/trade-15.5ac08298.png";